import React from 'react';
import { motion } from 'framer-motion';
import { Star, Gift, Clock, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <>
      {/* Sticky Offer Banner */}
      <div className="sticky top-0 z-50 bg-[#D4AF37] text-white py-2 px-4 text-center shadow-md" data-id="element-85">
        <div className="flex items-center justify-center gap-2 text-sm md:text-base font-medium" data-id="element-86">
          <Gift className="w-4 h-4" data-id="element-87" />
          <span data-id="element-88">
            Oferta de inicio de año: Solo $9.97 + 3 BONOS GRATIS (Valor $69.89)
          </span>
        </div>
      </div>

      {/* Main Hero */}
      <section className="relative overflow-hidden bg-[#FFF9F5] pt-12 pb-20 md:pt-20 md:pb-32" data-id="element-89">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-90">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#FF6B6B]/5 rounded-full blur-3xl" data-id="element-91" />
          <div className="absolute top-1/2 -left-24 w-72 h-72 bg-[#D4AF37]/10 rounded-full blur-3xl" data-id="element-92" />
        </div>

        <div className="container mx-auto px-4 relative z-10" data-id="element-93">
          <div className="max-w-6xl mx-auto" data-id="element-94">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-95">
              {/* Left Column - Text Content */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} data-id="element-96">
                <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-1.5 rounded-full shadow-sm mb-6 border border-[#D4AF37]/20" data-id="element-97">
                  <Star className="w-4 h-4 text-[#D4AF37] fill-current" data-id="element-98" />
                  <span className="text-sm font-semibold text-gray-700 tracking-wide uppercase" data-id="element-99">
                    Oferta Especial de temporada
                  </span>
                  <Star className="w-4 h-4 text-[#D4AF37] fill-current" data-id="element-100" />
                </div>

                <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 mb-6 leading-tight" data-id="element-101">
                  La casa impecable que deseas{' '}
                  <span className="text-[#2C7A7B]" data-id="element-102">sin sacrificar tu vida</span>
                </h1>

                <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-103">
                  El método científicamente comprobado para un hogar limpio,
                  saludable y reluciente en solo{' '}
                  <span className="font-bold text-[#2C7A7B]" data-id="element-104">
                    15 minutos al día
                  </span>{' '}
                  usando solo{' '}
                  <span className="font-bold text-[#2C7A7B]" data-id="element-105">
                    2 ingredientes
                  </span>
                  .
                </p>

                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10" data-id="element-106">
                  <div className="flex items-center gap-2 text-gray-600 bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-107">
                    <Clock className="w-5 h-5 text-[#FF6B6B]" data-id="element-108" />
                    <span className="font-medium" data-id="element-109">Solo 15 min/día</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-600 bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-110">
                    <Sparkles className="w-5 h-5 text-[#FF6B6B]" data-id="element-111" />
                    <span className="font-medium" data-id="element-112">Resultados inmediatos</span>
                  </div>
                </div>

                <div className="flex flex-col items-start gap-4" data-id="element-113">
                  <a href="https://coneckta.store/cart/47395411984628:1" className="w-full sm:w-auto" data-id="element-114">
                    <Button size="xl" withPulse className="w-full shadow-xl shadow-[#FF6B6B]/20" data-id="element-115">
                      Sí, quiero mi hogar impecable
                    </Button>
                  </a>
                  <p className="text-sm text-gray-500" data-id="element-116">
                    Descarga inmediata · Acceso de por vida · Pago único
                  </p>
                </div>
              </motion.div>

              {/* Right Column - Product Image */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="relative" data-id="element-117">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-118">
                  <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766518642/Primera_foto_Ebook_oy8csg.webp" alt="Casa Impecable - Ebook con bonos gratis, Oferta $9.97" className="w-full h-auto" loading="eager" data-id="element-119" />
                </div>
                {/* Decorative glow */}
                <div className="absolute -inset-4 bg-[#D4AF37]/20 rounded-3xl blur-3xl -z-10" data-id="element-120" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </>;
}